import React, { Component, useEffect } from 'react';

import {HashRouter, Route, Switch} from 'react-router-dom';



//import './App.css';

import './dist/css/studypurse.css'
import './dist/css/studypurse-device.css'
import './dist/css/bootstrap.min.css';

import { Spinner } from 'react-bootstrap';
import NProgress from 'nprogress';


import GuestRoute from './components/GuestRoute';
import AuthRoute from './components/AuthRoute';


import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import HelmetMetaData from './inc/HelmetMetaData';
import Notifications from './home/notification/Notifications';
import Purse from './home/savings/Purse';
import SmartPurseSavings from './home/savings/SmartPurseSavings';


            




const loading2 = (
  <div className="pt-56 my-0 text-center py-64 h-screen bg-white">

      {/* <img src={require('./dist/images/studypurse2.gif')} width={200} className="m-auto" /> */}
      <img src={require('./dist/images/studypurse.gif')} width={100} className="m-auto" />
  </div>
);



const Dashboard = React.lazy(()=> import('./home/dasboard/Dashboard'))
const Payment = React.lazy(()=> import('./home/payment/Payment'))
const Savings = React.lazy(()=> import('./home/savings/Savings'))
const History = React.lazy(()=> import('./home/history/History'))
const Referral = React.lazy(()=> import('./home/referral/Referral'))

//const Fundraise = React.lazy(()=> import('./home/campaign/Fundraise'))


const Profile = React.lazy(()=> import('./home/profile/Profile'))
const Landing = React.lazy(()=> import('./Landing'))

//Login
const Login = React.lazy(()=> import('./authentication/Login'))

//Register
const Register = React.lazy(()=> import('./authentication/Register'))

//Complete
const Complete = React.lazy(()=> import('./authentication/Complete'))

class App extends Component {

  render(){
    return (
      
      <div>

      <HashRouter>
        <React.Suspense fallback={loading2}>
          <HelmetMetaData></HelmetMetaData>
          <Switch>
            <GuestRoute path='/' exact component={ Login } />
            {/* <Route path='/' exact render={props => <Landing {...props} />} /> */}
            

            <GuestRoute path='/login' exact component={ Login } />
            <GuestRoute path='/register' exact component={Register} />
            <GuestRoute path='/complete-registration' exact component={Complete} />

            <AuthRoute path='/dashboard' component={Dashboard } />
            <AuthRoute path='/payment' exact component={Payment} />
            <AuthRoute path='/savings' component={ Savings } />
            <AuthRoute path='/history' component={History} />
            <AuthRoute path='/referral' component={Referral } />
            <AuthRoute path='/profile' component={Profile } />
            <AuthRoute path='/notifications' component={Notifications} />
            <AuthRoute path='/mypurse/:id'  component={Purse} />
            <AuthRoute path='/my-smartpurse'  component={SmartPurseSavings} />

          </Switch>
        </React.Suspense>
      </HashRouter>
      <ToastContainer className="f-visby" />
      </div>
    );
  }
}

export default App;
